
import { activeSync } from '../api.js'

import notifications from '../notifications.js'

var _currentData = undefined

function _remapData(originalData) {
  return {
    id: originalData.id,
    sendEmail: originalData['send_email'],
    sendNoreplyEmail: originalData['send_noreply_email'],
    syncBuilding: originalData['sync_building'],
    syncStudent: originalData['sync_student'],
    errorLogs: {
      sendEmail: originalData['error_send_email'],
      sendNoreplyEmail: originalData['error_send_noreply_email'],
      syncBuilding: originalData['error_sync_building'],
      syncStudent: originalData['error_sync_student'],
    },
    internalId: originalData['student__internal_id'],
    studentName: `${originalData['student__first_name']} ${originalData['student__last_name']}`,
    type: originalData['type'],
    createdAt: originalData['created_at'],
  }
}

async function _getData(params) {
  try {
    let response = await activeSync.getScheduleRequestsControlPanel(params)
    _currentData = response.data
    return _currentData
  }
  catch (error) {
    notifications.pushError(`Unable to load Schedule Requests Control Panel Data! ${error.response.data.error}`, error)
  }
}

async function _getSingleRequest(scheduleRequestId) {
  try {
    let response = await activeSync.getStudentRequestsControlPanelData({ ids: [scheduleRequestId] })
    return _remapData(response.data['meta_schedule_request_data'][0])
  }
  catch (error) {
    notifications.pushError(`Failed to get schedule request control panel data! ${error.response.data.error}`, error)
  }
}

async function _getRequests(scheduleRequestIds) {
  try {
    let response = await activeSync.getStudentRequestsControlPanelData({ ids: scheduleRequestIds })
    return response.data['meta_schedule_request_data'].map(_remapData)
  }
  catch (error) {
    notifications.pushError(`Failed to get schedule request control panel data! ${error.response.data.error}`, error)
  }
}

async function _runTask(taskType, scheduleRequestId) {
  try {
    await activeSync.postStudentRequestsControlPanelRunTask(taskType, scheduleRequestId)
  }
  catch (error) {
    notifications.pushError(`Failed to run async task! ${error.response.data.error}`, error)
  }
}

async function _errorLogs() {
  try {
    let response = await activeSync.getStudentRequestsControlPanelErrorLog()
    return response.data
  }
  catch (error) {
    notifications.pushError(`Failed to get error logs! ${error.response.data.error}`, error)
  }
}

export default {
  getData: _getData,
  getSingleRequest: _getSingleRequest,
  getRequests: _getRequests,
  runTask: _runTask,
  errorLogs: _errorLogs,
  remapData: _remapData,
}
